export default __webpack_public_path__ + "static/media/scan-danger.7e6e6dea.svg";